
import React, { Fragment, useEffect, useRef } from "react";
import "../../../../../../../assets/voucher.css";
import aiva_logo from "./../../../../../../../assets/aiva_logo.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindowMinimize, faWindowClose, faShoppingCart, faGift, faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { AxiosAPI } from "../../../../../../../helpers/AxiosAPI";
import { gAPI_Vouchers_List } from "../../../../../../../constants/APIs";
import { Spinner } from "reactstrap";
export default function PreviewVoucherList({ gid, pid, email, isLoading, hanldeLoading, propertyData, data, close_clicked, locale }) {
    const currencyFormat = (currency, value) =>
        new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currency
        }).format(value);



    // main document must be focused in order for window blur to fire when the iframe is interacted with. 
    // There's still an issue that if user interacts outside of the page and then click iframe first without clicking page, the following logic won't run. But since the OP is only concerned about first click this shouldn't be a problem.    
    const script =`  <script>
    var BMB_Voucher_domain = 'https://vouchers.getaiva.com/';
    var BMB_Voucher_botHTMLPath = BMB_Voucher_domain;
    var BMB_Voucher_head = document.getElementsByTagName('head')[0];
    var BMB_Voucher_script = document.createElement('script');
    BMB_Voucher_script.type = 'text/javascript';
    BMB_Voucher_script.src = BMB_Voucher_domain + 'voucherplugin.js';
    BMB_Voucher_head.appendChild(BMB_Voucher_script);
    var BMB_Voucher_gid = 'f49d1df2-f9b3-416e-a366-adf7ef6e7c63';
    var BMB_Voucher_iid = '7aa4700d-e53c-4643-b347-f9f895672c31';
    var BMB_Voucher_pid = '';
    </script>`;
 
    const InjectScript = (({ script }) => {
        const divRef = useRef(null);
    
        useEffect(() => {
          if (divRef.current === null) {
            return;
          }
          // create a contextual fragment that will execute the script
          // beware of security concerns!!
          const doc = document
              .createRange()
              .createContextualFragment(script)
          
          // clear the div HTML, and append the doc fragment with the script 
          divRef.current.innerHTML = ''
          divRef.current.id = "testScriptName";
          divRef.current.appendChild(doc);
          
        })
    
        return <div ref={divRef} />
      });
    return (
        <Fragment>
                 {/* <InjectScript script={script}></InjectScript> */}
            {/* <iframe class="bmb_voucher_frame_default"
                style={{ position: 'fixed', bottom: 0, right: 0, margin: 0, zIndex: 9999998 }}
                id="voucherbotiframe"
                src="https://vouchers.devtest.getaiva.com/voucherengine?iid=4405ff2e-82e0-427a-bd6a-01309d4a3dc9&gid=73574010-2f33-4b41-8b8a-09d18b025a56"
                //          src="https://vouchers.getaiva.com/voucherengine?gid=f49d1df2-f9b3-416e-a366-adf7ef6e7c63&amp;iid=7aa4700d-e53c-4643-b347-f9f895672c31"
                frameBorder="0"></iframe> */}


        </Fragment>
    );

}